module.exports = __webpack_public_path__ + "static/img/water7.45f7d129.webp";